// @flow
export default (a: number = 0, b: number = 0, desc: boolean = false) => (desc ? b - a : a - b)
